import React, { Component } from "react";
import { axiosPost } from "../../utils/AxiosApi";
import { URL } from "../../utils/Constants";
import { displayErrorAlert } from "../../utils/DisplayMessage";
import CustomPageHeader from "../common/CustomPageHeader";
import "../../assets/scss/FeedbackModule.scss";
import ModalWindow from "../UI/ModalWindow";
import FeedbackResponse from "./FeedbackResponse";

export class CentralFeedbackList extends Component {
  state = {
    feedbackLists: [],
    openResponse:false,
    selectedFeedback:null
  };

  componentDidMount() {
    this.getFeedbackList();
  }

  getFeedbackList = () => {
    axiosPost(
      URL.getAllFeedbacks,
      {},
      response => {
        if (response.status === 200) {
          this.setState({
            feedbackLists: response.data.data
          });
        }
      },
      err => {
        displayErrorAlert(err);
      }
    );
  };

   feedbackRating = (rating) => {
        const stars = [];
        for (let i = 1; i <= rating; i++) {
            stars.push(<span key={i} className="star active">★</span>);
        }
        return stars;
    }

  render() {
    return (
      <div>
        <div className="whiteContainer">
          <CustomPageHeader title="Feedbacks" />
          <table className="table cusTable">
            <thead>
              <tr>
                <th>Name</th>
                {/* <th>Email</th>
                <th>Contact No.</th> */}
                <th>Type</th>
                <th>Description</th>
                <th>Rating</th>
                <th>To</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {this.state.feedbackLists.length > 0 ? (
                this.state.feedbackLists.map((feedback, index) => {
                  return (
                    <tr>
                      <td >{feedback?.name ? feedback?.name : "-"}<br/>
                          <span className="badge badge-info">
                            {feedback?.schoolName}
                        </span>
                      </td>
                      <td>{feedback?.feedbackTypeName ? feedback?.feedbackTypeName : "-"}</td>
                      <td className="d-block text-truncate d-inline-block" style={{ maxWidth: "40vw" }}>
                        {feedback?.description ? feedback?.description : "-"}
                      </td>
                      <td>
                        {feedback.rating ? this.feedbackRating(feedback.rating) :"-"}
                      </td>
                      <td>
                        {feedback?.feedbackToPeopleName
                          ? feedback?.feedbackToPeopleName
                          : "-"}
                      </td>
                      <td>
                         <small className="btn btn-sm btn-outline-primary" onClick={() => this.setState({ openResponse: true, selectedFeedback: feedback })}>View
                            </small>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td className="text-center" colSpan={5}>
                    No records to display!!
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <ModalWindow
                backdrop="static"
                keyboard={false}
                fullWidth={false}
                modal={this.state.openResponse}
                toggleModal={() => this.setState({ openResponse: false })}
                noModelHeader={true}
                // modalHeader={modalTitle}
                modalBody={
                    // <FeedBackModule
                    // onSubmit={onSubmitFeedback}
                    // onCancel={onCancelFeedback}
                    // />
                    <FeedbackResponse
                        handleCancel={() => this.setState({ openResponse: false })}
                        feedback={this.state.selectedFeedback}
                    />
                }
            />
      </div>
    );
  }
}

export default CentralFeedbackList;
